<template>
  <v-form @submit.prevent="onSubmit()" ref="form">
    <v-card elevation="5">
      <v-img
        contain
        aspect-ratio="2"
        max-width="300px"
        max-height="150px"
        :src="imgSrc"
      ></v-img>
      <v-divider></v-divider>

      <v-card-subtitle>
        {{ titulo }}
      </v-card-subtitle>
      <v-divider></v-divider>

      <v-file-input v-model="FILE" accept="image/*" id="archivo" name="archivo" label="Archivo" type="file"
        ref="archivo" dense></v-file-input>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          dark
          icon
          :loading="loading"
          :disabled="archivo === '0.jpg' || archivo === ''"
          :href="imgSrc"
          target="_blank"
        >
          <v-icon dark>
            mdi-download
          </v-icon>
        </v-btn>
        <v-btn
          color="#B71C1C"
          dark
          icon
          @click="deleteImg(archivo)"
          :loading="loading"
          :disabled="categoria !== 'Galeria' || archivo === '0.jpg'"
        >
          <v-icon dark>
            mdi-delete
          </v-icon>
        </v-btn>
        <v-btn
          color="primary"
          dark
          icon
          type="submit"
          :loading="loading"
          :disabled="FILE === null"
        >
          <v-icon dark>
            mdi-content-save
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
  
<script>
  import { mapState } from "vuex";
  import axios from "axios";
  
  export default {
    data() {
      return {
        dialog: false,
        FILE: null,
        loading: false,
        updateImg: Math.floor(Math.random() * 100)
      }
    },
    props: {
      titulo: String,
      tipo: String,
      codigo: String,
      categoria: String,
      archivo: String
    },
    methods: {
      async onSubmit() {
        let respuesta
        const url = this.domoapi2_img
        const options = {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
        let Archivo = "";
        respuesta = await axios.post(`${this.domoapi2_img}Datos`, {
          tipo: this.tipo,
          codigo: this.checkCodigo,
          categoria: this.categoria,
          archivo: this.archivo
        });
        if (respuesta.status === 200) {
          const { data } = respuesta
          if (data.length != 0) {
            const { archivo } = data[0];
            Archivo = archivo
          }
        };

        const formData = new FormData()
        formData.append('tipo', this.tipo)
        formData.append('codigo', this.checkCodigo)
        formData.append('categoria', this.categoria)
        formData.append('archivo', this.FILE, this.FILE.name)

        try {
          this.loading = true
          if (Archivo !== "") {
            respuesta = await axios.put(`${url}${Archivo}`, formData, options)
          } else {
            respuesta = await axios.post(url, formData, options)
          }
          if (respuesta.status === 200) {
            const { data } = respuesta
            const { action } = data
            console.log(action)
          }
        }
        catch (error) {
          console.log(error)
        }
        finally {
          if (this.categoria === "Galeria") this.galeria()
          this.loading = false;
          this.updateImg = Math.floor(Math.random() * 100);
          this.FILE = null;
        }
      },
      async galeria() {
        let lista = []
        const respDatos = await axios.post(`${this.domoapi2_img}Datos`, {
            tipo: this.tipo,
            codigo: this.checkCodigo,
            categoria: this.categoria,
            archivo: ""
          });
          if (respDatos.status === 200) {
            const { data } = respDatos
            lista = data;
          };
          this.$emit("galeria", lista);
      },
      async deleteImg(archivo) {
        try {
          this.loading = true
          const resDel = await axios({
            method: 'delete',
            url: `${this.domoapi2_img}${archivo}`,
            data: {
              tipo: this.tipo,
              codigo: this.checkCodigo,
              categoria: this.categoria,
              archivo: this.archivo
            }
          })
          if (resDel.status === 200) {
            const { data } = resDel
            const { action } = data
            console.log(action)
          }
        }
        catch (error) {
          console.log(error)
        }
        finally {
          this.galeria()
          this.loading = false;
          this.updateImg = Math.floor(Math.random() * 100);
        }
      },
      ChrEsp(chr) {
        const chrSplit = chr.split("")
        let newChr = ""

        chrSplit.forEach(x => {
          if (x === "/") newChr += "-"
          else if (x === ".") newChr += "-"
          else newChr += x
        })

        return newChr
      },
    },
    computed: {
      ...mapState(["domoapi2_img"]),
      imgSrc() {
        let xSrc = this.domoapi2_img
        xSrc += this.tipo + "/"
        xSrc += this.checkCodigo + "/"
        xSrc += this.categoria + "?"
        xSrc += this.archivo !== '' ? 'archivo=' + this.archivo + '&' : ''
        xSrc += "i=" + this.updateImg

        return xSrc
      },
      checkCodigo() {
        return this.ChrEsp(this.codigo)
      },
    }
  }
  </script>